import React from 'react'
import {HubspotTag, useTestTag} from 'Event/hubspot'
import TestTagButton from 'organization/Event/Form/TestTagButton'
import {HIGHLEVEL} from 'organization/Event/Services/ServicesProvider'

export default function TestHubspotTagButton(props: {tag: HubspotTag | null}) {
  const addTag = useTestTag()

  return (
    <TestTagButton tag={props.tag} integration={HIGHLEVEL} addTag={addTag} />
  )
}
